import {ServicesService} from '../../rest-service/services.service';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Configuration} from '../../core/common/configuration';

@Injectable()
export class FileManagerService {

  protected readonly BASE_URL: string = '/file';

  constructor(protected services: ServicesService,
              protected config: Configuration) {
  }

  download(fileId: number, uri: string): Observable<Blob> {
    return this.services.download(
      uri + this.BASE_URL + '/download',
      {id: fileId}
    );
  }

}
